import i18n from '@/i18n';

export default [
    {
        get text() { return i18n?.global?.t('common.partId')},
        value: 'id',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.name')},
        value: 'name',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.registryNumber')},
        value: 'registry_no',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.quantity')},
        value: 'total_quantity',
    },
    {
        get text() { return i18n?.global?.t('common.unit')},
        value: 'preferred_unit',
        sortable: true,
    },
    { value: 'operation', width: 54, fixed: true },
];
